import { getRegionNameByCode } from './getRegionNameByCode';

export const getCountryURI = (countryCode: string) => {
  if (countryCode === 'TR') return 'turkey';

  if ('AE' === countryCode) {
    return 'united-arab-emirates';
  }

  const encodeURI = encodeURIComponent(
    (getRegionNameByCode('en').of(countryCode.toUpperCase()) ?? '')
      .replace('Côte d’Ivoire', 'cote-divoire')
      .replace('Myanmar (Burma)', 'myanmar')
      .replace('São Tomé & Príncipe', 'sao-tome-and-principe')
      .replace('ü', 'u')
      .replace(/\s-\s|\s/g, '-')
      .replace('.', '')
      .replace('&', 'and')
      .toLowerCase()
  );

  return decodeURIComponent(encodeURI);
};

export default getCountryURI;
